import { FEEDBACK_RATINGS, MESSAGE_ROLES } from '../../../../constants/aiAnalytics';

export const FEEDBACK_ACTION_LABELS = {
  [FEEDBACK_RATINGS.UP]: 'Good answer',
  [FEEDBACK_RATINGS.DOWN]: 'Bad answer'
};

const ADD_COMMENT_LABEL = 'Add a comment';
const EDIT_COMMENT_LABEL = 'Edit comment';

export function toggledRating(currentRating, clickedRating) {
  return currentRating === clickedRating ? null : clickedRating;
}

export function commentLinkLabel(comment) {
  return comment ? EDIT_COMMENT_LABEL : ADD_COMMENT_LABEL;
}

export function normalizeFeedback(feedback) {
  return { rating: feedback?.rating || null, comment: feedback?.comment || '' };
}

export function isRateableAnswer(message) {
  return Boolean(message) && message.role === MESSAGE_ROLES.ASSISTANT && !message.isError;
}
